// extracted by mini-css-extract-plugin
export default {"text":"styles__text--GIukV","header-1":"styles__header-1--arQQ6","header-2":"styles__header-2--uvlpT","header-3":"styles__header-3--qE5YK","compact":"styles__compact--T85ru"};